export const LIST_STATUS = {
  success: "success",
  info: "info",
  warning: "warning",
  error: "error"
}